export const SYMBOLS = {
  NuxtAxiosInstance: Symbol('NuxtAxiosInstance'),
  SentryInstance: Symbol('sentry'),
  SentryReadyInstance: Symbol('$sentryReady'),
}
